import React from "react";
import { socialIcons } from "utils/constants";

function SocialLinks() {
  return (
    <ul className="flex items-center space-x-3 md:space-x-4 order-1 md:order-3">
      {socialIcons.map((social) => (
        <li
          className="bg-lightGray/[.14] hover:bg-lightGray/10 text-lightGray hover:text-white w-[40px] h-[40px] rounded-full duration-300 -opacity-[.35]"
          key={social?.title}
        >
          <a
            className="w-full h-full inline-flex items-center justify-center -cursor-not-allowed"
            rel="noreferrer"
            href={social?.url}
          >
            {social?.img}
          </a>
        </li>
      ))}
    </ul>
  );
}

export default SocialLinks;
